/**
 * @file Submission read-only / review UI components — DatasetOverviewToolbar.tsx.
 */

import React from "react";

/** Type definition — Dataset Overview Toolbar Props. */
export type DatasetOverviewToolbarProps = {
  onExpandAll: () => void;
  onCollapseAll: () => void;
};

const DatasetOverviewToolbar: React.FC<DatasetOverviewToolbarProps> = ({
  onExpandAll,
  onCollapseAll,
}) => (
  <div className="submission-flow-toolbar">
    <button
      type="button"
      className="submission-flow-toolbar__btn"
      onClick={onExpandAll}
    >
      Expand all
    </button>
    <button
      type="button"
      className="submission-flow-toolbar__btn"
      onClick={onCollapseAll}
    >
      Collapse all
    </button>
  </div>
);

/** React component — Dataset Overview Toolbar. */
export default DatasetOverviewToolbar;
